import React from 'react';
import { Modal } from '../../Molecules';
import {Text} from "../../Atoms";
import PropTypes from "prop-types";

ModalConfirmRating.defaultProps = {
    text: "Merci pour votre avis, nous prenons en compte tous vos précieux retours.",
};
ModalConfirmRating.PropTypes = {
    text: PropTypes.string
};
function ModalConfirmRating(props) {
    return (
        <Modal
            {...props}
        >
            <div className="rating-confirm-container">
                <Text text={props.text} className="rating-confim-text" />
            </div>
        </Modal>
    );
}
export default ModalConfirmRating;
